package game.entity

import game.Game
import game.Room

class HealStation : Entity() {
    var coolDown = 0

    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById("heal-station")
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        if (coolDown > 0) {
            coolDown--
        } else {
            if (!game.player.fullHealth) {
                game.player.life++
                coolDown = 24
                game.playSound("heal")
            } else {
                game.message = game.text("Message_FullHealth")
            }
        }

        return true
    }
}
